import {skipToken} from '@reduxjs/toolkit/query';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetWorkshopInterestQuery} from '@dms/api/workshop';
import {workshopRoutes} from '@dms/routes';

import {composePath} from 'shared/web';

export function useTaskRelationWorkshopInterest(workshopInterestId: string) {
  const {
    data: workshopInterest,
    isLoading: isWorkshopInterestLoading,
    isError: isWorkshopInterestError,
  } = useGetWorkshopInterestQuery(
    isNotNilOrEmpty(workshopInterestId) ? {id: workshopInterestId} : skipToken
  );

  return {
    workshopInterest,
    customerId: workshopInterest?.customerId,
    isLoading: isWorkshopInterestLoading,
    isError: isWorkshopInterestError,
    pathname: composePath(workshopRoutes.interestDetailOverview, {
      params: {id: workshopInterestId},
      isSearchParamsPreserved: false,
    }),
  };
}
